
import { Component, Vue, Watch } from "vue-property-decorator";
import { searchCustomer } from "@/api/customer";
import { getInvoiceList } from "@/api/booking-order";
import Pagination from "@/components/Pagination/index.vue";
import { removeQuotation, getSalesmanList } from "@/api/inquiry";
import { updatePiRemark } from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import {
  getSettlementInfo,
  getSettlementInfoStatus,
  downloadSettlementInfo,
} from "@/api/invoice";
import checkPermission from "@/utils/permission_btn";
@Component({
  name: "settleAccountManagement",
  components: {
    Pagination,
  },
})
export default class extends Vue{
  private listLoading = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [
      {
        customerCode: "测试填充",
      },
    ] as any,
  };
  private listParam = {
    customerId: null,
    sellerId: null,
    allocableAmount: null,
    status: null,
  };
  private searchForm = [
    {
      label: "客人简称或编号",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "",
      remote: true,
      remote_method: this.searchCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "销售员",
      prop: "sellerId",
      key: "sellerId",
      type: "select",
      value: "",
      placeholder: "",
      remote: true,
      remote_method: this.getSalesmanList,
      clearable: true,
      options: [],
      resetKey: { label: "name", value: "id" },
    },
    {
      label: "待分配金额",
      prop: "allocableAmount",
      key: "allocableAmount",
      type: "select",
      value: "",
      options: [
        { label: "有", value: true },
        { label: "无", value: false },
      ],
      placeholder: "请选择",
      resetKey: { label: "label", value: "value" },
      clearable: true
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      type: "select",
      value: "",
      options: [],
      placeholder: "请选择",
      resetKey: { label: "desc", value: "name" },
    },
  ];
  created() {
    this.init();
  }
  activated() {
    this.init();
  }
  private init() {
    this.searchCustomer();
    this.getSalesmanList();
    this.getSettlementInfoStatus();
    this.getList();
  }
  private async getSettlementInfoStatus() {
    const res: any = await getSettlementInfoStatus();
    this.searchForm[3].options = res;
    let newOBJ: any = { desc: "全部", name: "ALL_STATUS" };
    this.searchForm[3].options.push(newOBJ);
  }
  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[1].options = res;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = true;
    const { total, content }: any = await getSettlementInfo(params);
    this.table.total = +total;
    this.table.list = content;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }
  private isExporting = false;

  // 导出
  private handleExport() {
    // this.isExporting = true;
    // let table = this.tableCol.slice(0, this.tableCol.length - 1);
    // const headers = table.map((v) => v.label);
    // const fieldNames = table.map((v) => v.key);
    // let list = deepClone(this.table.list);
    // exportJson2Excel(
    //   headers,
    //   formatJson(fieldNames, list),
    //   `客人IV管理-${new Date()}`
    // );
    // this.isExporting = false;
  }

  // 跳转IV管理
  private handleToIVM(row) {
    console.log("点击跳转查看详情", row.row);
    this.$router.push(
      `/iv-settle-account?customerId=${row.row.customerId}&customerCode=${
        row.row.customerCode
      }&customerAbbr=${row.row.customerAbbr}&status=${
        row.row.status
      }&unSettlementAmount=${
        row.row.unSettlementAmount
      }&allocatedAmountOfRemittanceAdvice=${
        row.row.allocatedAmountOfRemittanceAdvice
          ? row.row.allocatedAmountOfRemittanceAdvice
          : 0
      }&receivableAmount=${row.row.receivableAmount}`
    );
  }
  // 跳装 收汇单 并且携带客人参数
  private handleToSHD(row) {
    this.$router.push(
      `/collectionManagement?customerID=${row.row.customerId}`
    );
  }

  private async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 填写备注
  private async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      };
      await updatePiRemark(item.id, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }
  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }

  private querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.lastUpdateStart = time[0];
      rest.lastUpdateEnd = time[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private async downloadSearch(data) {
    const params = Object.assign({}, data);
    await downloadSettlementInfo(params);
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
  private handleCustomer() {
    console.log(1);
  }
  private checkBtnPermission(codes: string[]) {
    return checkPermission(codes, (this.$route.meta as any)?.buttonCodes);
  }
}
